import "../formProcessing.css";
import LeftMenu from "../../AnalyticsModule/Left";
import "../../AnalyticsModule/home.css"
import "../ECI/eciReport.css"
import { useNavigate } from "react-router-dom";

function EciReports() {
      let navigate = useNavigate();

      return (
            <>
                  <LeftMenu>
                        <div className="container pl-0 reports">
                              <div className="row">
                                    <div class="col-md-6">
                                          <div class="card l-bg-yellow-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/nodal/report/epb-downloading-record-officewise-nodal-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-person-rifle mr-2"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Downloading Report Record Office Wise
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-6">
                                          <div class="card l-bg-cyan-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/nodal/report/epb-downloading-unitofficewise-nodal-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-person-military-rifle mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Downloading Report Unit Office Wise
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-6">
                                          <div class="card l-bg-green-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/nodal/report/record-unit-pendency-nodal-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-envelopes-bulk mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                  Record / Unit Pending List
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-6">
                                          <div class="card l-bg-yellow-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/nodal/report/epb-downloading-report-phasewise-nodal-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-person-rifle mr-2"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                  e-Postal Ballot Downloading Report Phase Wise ( State Wise )
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </LeftMenu>
            </>
      );
}

export default EciReports;
